// import React, { useState, useRef, useEffect } from "react"
// import { Check, ChevronsUpDown, X } from "lucide-react"
// import { Button } from "@/components/ui/button"
// import { Input } from "@/components/ui/input"
// import { Badge } from "@/components/ui/badge"
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover"
//
// // Types
// export interface ComboboxOption {
//   value: string
//   label: string
// }
//
// interface ComboboxProps {
//   options: ComboboxOption[]
//   placeholder?: string
//   searchPlaceholder?: string
//   mode?: "single" | "multiple"
//   value?: string | string[]
//   onChange?: (value: string | string[]) => void
//   emptyMessage?: string
//   className?: string
//   disabled?: boolean
// }
//
// // Composant Combobox principal
// export const Combobox: React.FC<ComboboxProps> = ({
//   options,
//   placeholder = "Sélectionner ...",
//   searchPlaceholder = "Rechercher ...",
//   mode = "single",
//   value,
//   onChange,
//   emptyMessage = "Aucun résultat trouvé",
//   className = "",
//   disabled = false,
// }) => {
//   const [open, setOpen] = useState(false)
//   const [searchQuery, setSearchQuery] = useState("")
//   const searchInputRef = useRef<HTMLInputElement>(null)
//
//   // Gérer les valeurs sélectionnées
//   const selectedValues =
//     mode === "multiple"
//       ? Array.isArray(value)
//         ? value
//         : []
//       : value
//       ? [value as string]
//       : []
//
//   // Filtrer les options basées sur la recherche
//   const filteredOptions = options.filter((option) =>
//     option.label.toLowerCase().includes(searchQuery.toLowerCase())
//   )
//
//   // Gérer la sélection
//   const handleSelect = (optionValue: string) => {
//     if (mode === "single") {
//       onChange?.(optionValue)
//       setOpen(false)
//       setSearchQuery("")
//     } else {
//       const newValues = selectedValues.includes(optionValue)
//         ? selectedValues.filter((v) => v !== optionValue)
//         : [...selectedValues, optionValue]
//       onChange?.(newValues)
//     }
//   }
//
//   // Supprimer une sélection (mode multiple)
//   const handleRemove = (optionValue: string, e?: React.MouseEvent) => {
//     if (e) {
//       e.preventDefault()
//       e.stopPropagation()
//     }
//     if (mode === "multiple") {
//       const newValues = selectedValues.filter((v) => v !== optionValue)
//       onChange?.(newValues)
//     }
//   }
//
//   // Obtenir le label d'une option
//   const getOptionLabel = (optionValue: string) => {
//     return (
//       options.find((opt) => opt.value === optionValue)?.label || optionValue
//     )
//   }
//
//   // Focus sur l'input de recherche à l'ouverture
//   useEffect(() => {
//     if (open && searchInputRef.current) {
//       searchInputRef.current.focus()
//     }
//   }, [open])
//
//   // Réinitialiser la recherche à la fermeture
//   useEffect(() => {
//     if (!open) {
//       setSearchQuery("")
//     }
//   }, [open])
//
//   return (
//     <div className={className}>
//       <Popover open={open} onOpenChange={setOpen}>
//         <PopoverTrigger asChild>
//           <Button
//             variant="outline"
//             role="combobox"
//             aria-expanded={open}
//             disabled={disabled}
//             className="w-full justify-between">
//             <div className="flex flex-wrap gap-1 flex-1 items-center overflow-hidden">
//               {mode === "single" ? (
//                 <span
//                   className={
//                     selectedValues.length === 0 ? "text-muted-foreground" : ""
//                   }>
//                   {selectedValues.length > 0
//                     ? getOptionLabel(selectedValues[0])
//                     : placeholder}
//                 </span>
//               ) : (
//                 <>
//                   {selectedValues.length === 0 ? (
//                     <span className="text-muted-foreground">{placeholder}</span>
//                   ) : (
//                     selectedValues.map((val) => (
//                       <div key={val} className="inline-flex items-center gap-1">
//                         <Badge variant="secondary">{getOptionLabel(val)}</Badge>
//                         <button
//                           type="button"
//                           onClick={(e) => handleRemove(val, e)}
//                           className="rounded-sm hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring p-0.5">
//                           <X className="h-3 w-3 text-muted-foreground hover:text-foreground" />
//                         </button>
//                       </div>
//                     ))
//                   )}
//                 </>
//               )}
//             </div>
//             <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
//           </Button>
//         </PopoverTrigger>
//
//         <PopoverContent className="w-full p-0" align="start">
//           {/* Barre de recherche */}
//           <div className="border-b p-2">
//             <Input
//               ref={searchInputRef}
//               placeholder={searchPlaceholder}
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="h-9"
//             />
//           </div>
//
//           {/* Liste des options */}
//           <div className="max-h-60 overflow-y-auto p-1">
//             {filteredOptions.length === 0 ? (
//               <div className="py-6 text-center text-sm text-muted-foreground">
//                 {emptyMessage}
//               </div>
//             ) : (
//               filteredOptions.map((option) => {
//                 const isSelected = selectedValues.includes(option.value)
//
//                 return (
//                   <div
//                     key={option.value}
//                     className={`flex items-center gap-2 rounded-sm px-2 py-2 text-sm cursor-pointer transition-colors ${
//                       isSelected ? "bg-accent" : "hover:bg-accent/50"
//                     }`}
//                     onClick={() => handleSelect(option.value)}>
//                     {mode === "multiple" ? (
//                       <>
//                         <div
//                           className={`h-4 w-4 rounded border flex items-center justify-center ${
//                             isSelected
//                               ? "bg-primary border-primary"
//                               : "border-input"
//                           }`}>
//                           {isSelected && (
//                             <Check className="h-3 w-3 text-primary-foreground" />
//                           )}
//                         </div>
//                         <span className="flex-1">{option.label}</span>
//                       </>
//                     ) : (
//                       <>
//                         <span className="flex-1">{option.label}</span>
//                         {isSelected && (
//                           <Check className="h-4 w-4 text-primary" />
//                         )}
//                       </>
//                     )}
//                   </div>
//                 )
//               })
//             )}
//           </div>
//         </PopoverContent>
//       </Popover>
//     </div>
//   )
// }
//
// export default Combobox
import React, { useState, useRef, useEffect } from 'react';
import { Check, ChevronsUpDown, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';

// Types
export interface ComboboxOption {
  value: string;
  label: string;
}

interface ComboboxProps {
  options: ComboboxOption[];
  placeholder?: string;
  searchPlaceholder?: string;
  mode?: 'single' | 'multiple';
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  emptyMessage?: string;
  className?: string;
  disabled?: boolean;
}

// Composant Combobox principal
export const Combobox: React.FC<ComboboxProps> = ({
  options,
  placeholder = 'Sélectionner ...',
  searchPlaceholder = 'Rechercher ...',
  mode = 'single',
  value,
  onChange,
  emptyMessage = 'Aucun résultat trouvé',
  className = '',
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const containerRef = useRef<HTMLDivElement>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);

  // Gérer les valeurs sélectionnées
  const selectedValues = mode === 'multiple'
    ? (Array.isArray(value) ? value : [])
    : (value ? [value as string] : []);

  // Filtrer les options basées sur la recherche
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Gérer la sélection
  const handleSelect = (optionValue: string) => {
    if (mode === 'single') {
      onChange?.(optionValue);
      setOpen(false);
      setSearchQuery('');
    } else {
      const newValues = selectedValues.includes(optionValue)
        ? selectedValues.filter((v) => v !== optionValue)
        : [...selectedValues, optionValue];
      onChange?.(newValues);
    }
  };

  // Supprimer une sélection (mode multiple)
  const handleRemove = (optionValue: string, e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (mode === 'multiple') {
      const newValues = selectedValues.filter((v) => v !== optionValue);
      onChange?.(newValues);
    }
  };

  // Obtenir le label d'une option
  const getOptionLabel = (optionValue: string) => {
    return options.find((opt) => opt.value === optionValue)?.label || optionValue;
  };

  // Fermer le dropdown en cliquant à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
        setSearchQuery('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Focus sur l'input de recherche à l'ouverture
  useEffect(() => {
    if (open && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [open]);

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      {/* Bouton principal */}
      <div
        // type="button"
        // variant="outline"
        role="combobox"
        aria-expanded={open}
        className="w-full flex justify-between px-3 py-2 border border-gray-300 rounded-sm"
        onClick={() => { if(!disabled){ setOpen(!open) } } }
      >
        <div className="flex flex-wrap gap-1 flex-1 items-center">
          {mode === 'single' ? (
            <span className={selectedValues.length === 0 ? 'text-gray-500' : ''}>
              {selectedValues.length > 0
                ? getOptionLabel(selectedValues[0])
                : placeholder}
            </span>
          ) : (
            <>
              {selectedValues.length === 0 ? (
                <span className="text-gray-500">{placeholder}</span>
              ) : (
                selectedValues.map((val) => (
                  <div key={val} className="inline-flex items-center gap-1">
                    <Badge>{getOptionLabel(val)}</Badge>
                    <button
                      type="button"
                      onClick={(e) => handleRemove(val, e)}
                      className="rounded-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 p-0.5"
                    >
                      <X className="h-3 w-3 text-gray-500 hover:text-gray-700" />
                    </button>
                  </div>
                ))
              )}
            </>
          )}
        </div>
        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
      </div>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-50 mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg">
          {/* Barre de recherche */}
          <div className="border-b border-gray-200 p-2">
            <Input
              ref={searchInputRef}
              placeholder={searchPlaceholder}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="h-9"
            />
          </div>

          {/* Liste des options */}
          <div className="max-h-60 overflow-y-auto p-1">
            {filteredOptions.length === 0 ? (
              <div className="py-6 text-center text-sm text-gray-500">
                {emptyMessage}
              </div>
            ) : (
              filteredOptions.map((option) => {
                const isSelected = selectedValues.includes(option.value);

                return (
                  <div
                    key={option.value}
                    className={`flex items-center gap-2 rounded-sm px-2 py-2 text-sm cursor-pointer transition-colors ${
                      isSelected
                        ? 'bg-gray-100'
                        : 'hover:bg-gray-50'
                    }`}
                    onClick={() => handleSelect(option.value)}
                  >
                    {mode === 'multiple' ? (
                      <>
                        <div
                          className={`h-4 w-4 rounded border flex items-center justify-center ${
                            isSelected
                              ? 'bg-blue-600 border-blue-600'
                              : 'border-gray-300'
                          }`}
                        >
                          {isSelected && <Check className="h-3 w-3 text-white" />}
                        </div>
                        <span className="flex-1">{option.label}</span>
                      </>
                    ) : (
                      <>
                        <span className="flex-1">{option.label}</span>
                        {isSelected && (
                          <Check className="h-4 w-4 text-blue-600" />
                        )}
                      </>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Combobox;